import React from 'react';
import { Award } from 'lucide-react';

const STYLES = {
  'Acquitté': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Partiel': 'bg-amber-50 text-amber-700 border-amber-200',
  'Incident de paiement': 'bg-red-50 text-red-700 border-red-200',
};

/** Ligne du tableau des membres : petit badge « Adhérent COPPAM » (souscriptions en cours de validité). */
export function CoppamRowBadge({ resume, mid }) {
  if (!resume || !resume.nombre) return null;
  const fin = new Date(resume.prochaine_expiration).toLocaleDateString('fr-FR');
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full border text-[10px] font-semibold flex-shrink-0 ${STYLES[resume.statut_paiement] || STYLES.Partiel}`}
      title={`${resume.nombre} souscription(s) en cours de validité — prochaine expiration le ${fin} — paiement : ${resume.statut_paiement}`}
      data-testid={`badge-adherent-coppam-${mid}`}
    >
      <Award className="h-3 w-3" />
      <span className="hidden sm:inline">Adhérent COPPAM</span>
      {resume.nombre > 1 && <span>×{resume.nombre}</span>}
    </span>
  );
}
